// export default function enableGliaScript(enableGlia = false) {
export default function enableGliaScript(enableGlia = false) {
  if (!enableGlia) return null;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://api.salemove.com/salemove_integration.js';
  script.id = 'glia-bt';
  script.dataset.enableGlia = enableGlia;
  return document.head.appendChild(script);
}
